module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-category"
  }, [_c('div', {
    staticClass: "panel h1-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/kb"
    }
  }, [_vm._v("Knowledge Base")])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "panel results-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "category-heading"
  }, [(_vm.category.imageUrl) ? _c('img', {
    attrs: {
      "src": _vm.category.imageUrl
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/img/ttto-thumbnail.jpg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.formatCategoryArticlesTitle(_vm.category, _vm.articles)))])]), _vm._v(" "), (_vm.articles.length > 0 || _vm.canAuthor) ? _c('div', [_c('ol', [_vm._l((_vm.articles), function(article) {
    return _c('li', [_c('kb-block-link', {
      staticClass: "article-block",
      attrs: {
        "to": _vm.getArticleLocation(article)
      }
    }, [_c('div', {
      staticClass: "article-wrapper"
    }, [(_vm.getCoverImageUrl(article)) ? _c('img', {
      attrs: {
        "src": _vm.getCoverImageUrl(article)
      }
    }) : _c('img', {
      attrs: {
        "src": require("../assets/img/ttto-thumbnail.jpg")
      }
    }), _vm._v(" "), _c('div', [_c('h3', [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('p', [_c('BlockEllipsis', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(article.overview)
      }
    })])], 1)])])])], 1)
  }), _vm._v(" "), (_vm.canAuthor) ? _c('li', [_c('kb-block-link', {
    attrs: {
      "title": "Create an article",
      "to": _vm.getArticleEditorLocation(_vm.category)
    }
  })], 1) : _vm._e()], 2)]) : _vm._e()]) : _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Loading...\n            ")])])]), _vm._v(" "), _c('kb-feedback')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Category")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2698719f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbCategory.vue
// module id = 1973
// module chunks = 2